import { Component, input } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-settings-01',
  imports: [],
  templateUrl: './settings-01.html',
  styleUrl: './settings-01.scss',
})
export class Settings01 {
  stroke = input('#797674');
  width = input('1rem');
  height = input('1rem');
}
